// extracted by mini-css-extract-plugin
module.exports = {"payment-info":"payment-info__3mnen","heading":"heading__3N9b5","card-number":"card-number__s6nPd","brand-icon":"brand-icon__1UHxb","card-number-text":"card-number-text__1yV5v"};